<ng-container
  *ngIf="
    contentBlock?.sectionType === 'media_cards' ||
    contentBlock?.sectionType === 'media_cards_list'
  "
>
  <ft-media-cards-section
    [content]="contentBlock"
    [page]="page"
  ></ft-media-cards-section>
</ng-container>
<ng-container *ngIf="contentBlock?.sectionType === 'media_card_index'">
  <ft-media-cards-index
    [content]="contentBlock"
    [page]="page"
  ></ft-media-cards-index>
</ng-container>
<ng-container
  *ngIf="
    contentBlock?.sectionType === 'thumbnail_cards' ||
    contentBlock?.sectionType === 'thumbnail_cards_compact'
  "
>
  <ft-thumbnails-section
    [content]="contentBlock"
    [page]="page"
  ></ft-thumbnails-section>
</ng-container>
